var map = {
	"./bg.json": [
		1326,
		387
	],
	"./cs.json": [
		1327,
		386
	],
	"./da.json": [
		1328,
		385
	],
	"./de.json": [
		1329,
		384
	],
	"./el.json": [
		1330,
		383
	],
	"./en.json": [
		172
	],
	"./es.json": [
		1331,
		382
	],
	"./fr.json": [
		1332,
		381
	],
	"./hr.json": [
		1333,
		380
	],
	"./hu.json": [
		1334,
		379
	],
	"./id.json": [
		1335,
		378
	],
	"./it.json": [
		1336,
		377
	],
	"./ko.json": [
		1337,
		376
	],
	"./nl.json": [
		1338,
		375
	],
	"./pt-BR.json": [
		1339,
		374
	],
	"./pt.json": [
		1340,
		373
	],
	"./ro.json": [
		1341,
		372
	],
	"./ru.json": [
		1342,
		371
	],
	"./sv.json": [
		1343,
		370
	],
	"./tr.json": [
		1344,
		369
	],
	"./zh-CN.json": [
		1345,
		368
	],
	"./zh-tw.json": [
		1346,
		367
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 988;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/translations lazy ^\.\/.*\.json$
// module id = 988
// module chunks = 389